<script>
import Service from '../../services/fiscal-notification';
import ExciseCalculatorService from '../../services/excise-calculator';
import CommonConstants from '../../common/Constants';

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

// import Dropdown from 'primevue/dropdown';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue'
// import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'
import GenericDateTimeMaskV2 from '../../components/generic/GenericDateTimeMaskV2.vue'
import GenericDateMaskV2 from '../../components/generic/GenericDateMaskV2.vue'
import config from '../../common/genericPanelConf';
import Calendar from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber';

import Message from 'primevue/message';

import ConfirmLoginDialog from '../../components/security/ConfirmLoginDialog.vue'
import Utils from '../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import InfoilDeviationCheck from '../../components/fiscal-notification/InfoilDeviationCheck.vue';

  export default{
    setup: () => ({ v$: useVuelidate() }),
    components: {
      DataTable, Column, 
      GenericCustomAutocompleteV2, //GenericCustomMasterDataAutocompleteV2,
      GenericDateTimeMaskV2, GenericDateMaskV2, 
      //GenericBooleanDropdown,
      // Dropdown,
      InfoilDeviationCheck,
      ResponsiveButton,
      Message, ConfirmLoginDialog, Calendar, InputNumber
    },
    data(){
      return {
        submitted: false,
        idScheduledOperation: this.$route.query.idScheduledOperation,
        selectedFiscalNotification: null,
        editable: false,
        fiscalNotification: {
          id: null,
          isFinal: false,
          canFinalize: false,
          infoilNumber: null,
          infoilDate: null,
          utifProgramCode: null,
          notificationSendDate: null,
          notificationCode: null,
          notificationNumber: null,
          idRegistryFiscalNotificationState: null,
          fiscalNotificationState: null,
          idRegistryOperation: null,
          registryOperation: null,
          isMovementInstruction: null,
          isBySea: null,
          movementDirectionFlag: null,
          endOperationDate: null,
          idRegistryProduct: null,
          productDescription: null,
          idFiscalCircuit: null,
          fiscalCircuitCode: null,
          nc: null,
          quantity: null,
          sentBy: null,
          idRegistryPlant : null,
          voyageNumber: null,
          vesselName: null,
          portOrLocationOfFiscalDestinationDescription: null,
          placeOfDeliveryName: null,
          portOrLocationOfLoading: null,
          placeOfFiscalDestinationDescription: null,
          customAgencyDescription: null,
          idRegistryFiscalPosition: null,
          registryFiscalPositionCode: null,
          placeOfDeliveryExciseCode: null,
          originCountry: null,
          exciseDuty: null,
          exciseDue: null,
          documentReference: null,
          note: null,
          totalFiscalMovedWeight: null,
          totalFiscalMovedVolume: null
        },
        fiscalNotificationDetails: [],
        fiscalNotificationEquipmentList: [],
        collapseNotificationPanel: false,
        collapseNotificationDetailsPanel: false,
        collapseEquipmentListPanel: false,
        disableEdit: true,
        disableDelete: true,
        selectedReinsertTank: null,
        selectedNotificationDetail: null,
        updates: {
          isMovementInstructionModified: false,
          isScheduledOperationModified: false
        },
        reinsertTankList: [],
        editItem: {},
        originalEditItem: {},
        editDetailVisible: false,
        editDisplacingDetailVisible: false,

        selectedTankNew: null,
        errorSendDialogVisible: false,
        errorSendMessage: '',
        stateComboItems: [],
        infoilDeviationCheckDialogVisible: false,
        deviationData: null
      }
    },
    validations(){
      return {
        fiscalNotification: {
          idFiscalCircuit: (data) => {
            return data.idFiscalCircuit
          },
          idEnergyProductDetail: {required},
          notificationSendDate: {required},
          endOperationDate: (data) => {
            if(data.fiscalNotificationState == 'CC'){
            // if(data.isFinal){
              return data.endOperationDate;
            }
            return true;
          },
          portOrLocationOfFiscalDestinationDescription: (data) => {
            if(data.isMovementInstruction && data.isBySea && data.movementDirectionFlag != 'E'){
              return data.portOrLocationOfFiscalDestinationDescription;
            }
            return true;
          },
          placeOfFiscalDestinationDescription: (data) => {
            if(data.isMovementInstruction && data.isBySea && data.movementDirectionFlag != 'E'){
              return data.placeOfFiscalDestinationDescription;
            }
            return true;
          },
          portOrLocationOfLoading: (data) => {
            if(data.isMovementInstruction && data.movementDirectionFlag != 'U'){
              return data.portOrLocationOfLoading;
            }
            return true;
          },
          originCountry: (data) => {
            if(data.isMovementInstruction && data.movementDirectionFlag != 'U'){
              return data.originCountry;
            }
            return true;
          },
          documentReference: (data) => {
            if(data.isFinal && data.isMovementInstruction){
              return data.documentReference;
            }
            return true;
          }
        }
      }
    },
    created(){
      this.configNotification = config.getConfiguration('FiscalNotificationHeader');
      this.configDetails = config.getConfiguration('FiscalNotificationDetails');
      this.loadNotifications();
    },
    mounted() {
      this.$store.dispatch('security/setNavbarTitle', 'fiscalNotification.detail_page_title');
    },
    methods: {
      onFiscalNotificationSelected(){

      },
      loadNotifications(){
        Service.getFiscalNotificationCombo(this.idScheduledOperation, response => {
          if(response.data.length){
            this.$refs.fiscalNotificationCombo.changeStaticOptions([...response.data]);
            // this.selectedFiscalNotification = response.data[response.data.length-1].value;
          }else{
            this.$refs.fiscalNotificationCombo.changeStaticOptions([]);
            this.loadNext();
          }
        });
      },
      loadCurrent(){
        this.editable = false;
        // this.checkForUpdate();
        this.loadHeader();
        this.loadDetails();
        this.loadEquipments();
      },
      loadHeader(){
          this.$store.dispatch("generic/setLoading", true);
          this.stateComboItems = [];
          Service.getFiscalNotificationHeader(this.selectedFiscalNotification, ({success, message, data}) => {
            this.$store.dispatch("generic/setLoading", false);
            if(success){
              this.fiscalNotification = data;
              this.stateComboItems.push({label: data.fiscalNotificationState});
              if(data.fiscalNotificationState != 'CC' && data.fiscalNotificationState != 'CA'){
                this.checkForUpdate();
              }

              let getOnlyValid = this.editable;
              this.$refs.ncCombo.loadOptions(`masterdata/energy-product-detail-combonc?idProduct=${this.fiscalNotification.idRegistryProduct}&transportType=${this.fiscalNotification.transportType}&getOnlyValid=${getOnlyValid}`);
              this.setDisableEdit();
            }else{
              this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          });
      },
      loadDetails(){
          this.fiscalNotificationDetails = [];
          Service.getFiscalNotificationDetailsByHeader(this.selectedFiscalNotification, ({success, message, data}) => {
            if(success){
              this.fiscalNotificationDetails = data;
              this.reinsertTankList = [];
              let grouped = {};
              for(let i = 0; i< data.length; i++){
                let singleOperation = data[i];

                if(!grouped[singleOperation.idEquipmentOperationTank]){
                  grouped[singleOperation.idEquipmentOperationTank] = [];
                }

                grouped[singleOperation.idEquipmentOperationTank].push(singleOperation);

              }
              for(var key in grouped){
                let operations = grouped[key];
                let ccCount = operations.filter(item => item.fiscalNotificationState == 'CC').length;
                let allCount = operations.length;
                if(ccCount == allCount){
                  this.reinsertTankList.push(operations[0])
                }
              }
            }else{
              this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          });
      },
      loadEquipments(){
          this.fiscalNotificationEquipmentList = [];
          Service.getFiscalNotificationLayout(this.selectedFiscalNotification, ({success, message, data}) => {
            if(success){
              this.fiscalNotificationEquipmentList = data;
            }else{
              this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          });
      },
      checkForUpdate(){
         this.updates = {
            isMovementInstructionModified: false,
            isScheduledOperationModified: false
          };
        Service.getFiscalNotificationCheckForUpdate(this.idScheduledOperation, ({success, data}) => {
          if(success){
            this.updates = data;
          }
        });
      },
      loadNext(){
        this.editable = true;
        this.loadNextHeader();
        this.loadNextDetails();
        this.loadNextEquipments();
      },
      loadNextHeader(){
        this.$store.dispatch("generic/setLoading", true);
          this.stateComboItems = [];
        Service.getFiscalNotificationHeaderNext(this.idScheduledOperation, ({success, message, data}) => {
          this.$store.dispatch("generic/setLoading", false);
          if(success){
            this.fiscalNotification = data;
            this.setDisableEdit();

            this.stateComboItems.push({label: data.fiscalNotificationState});
            if(data.fiscalNotificationState == 'CC'){
              this.stateComboItems.push({label: 'CCP'});
            }

            this.$refs.fiscalNotificationCombo.addStaticOption({
              label: data.fiscalNotificationState,
              value: 0,
              extraData: data.notificationSendDate
            }, true);
            let getOnlyValid = this.editable;
            this.$refs.ncCombo.loadOptions(`masterdata/energy-product-detail-combonc?idProduct=${this.fiscalNotification.idRegistryProduct}&transportType=${this.fiscalNotification.transportType}&getOnlyValid=${getOnlyValid}`);
          }else{
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        });
      },
      loadNextDetails(){
          this.fiscalNotificationDetails = [];
          Service.getFiscalNotificationDetailNext(this.idScheduledOperation, ({success, message, data}) => {
            if(success){
              this.fiscalNotificationDetails = data;
            }else{
              this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          });
      },
      loadNextEquipments(){
          this.fiscalNotificationEquipmentList = [];
          Service.getFiscalNotificationLayoutNext(this.idScheduledOperation, ({success, message, data}) => {
            if(success){
              this.fiscalNotificationEquipmentList = data;
            }else{
              this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          });
      },
      onFiscalCircuitSelected(){
      },
      onEnergyProductDetailSelected(){

      },
      isHidden(isHidden) {
        return typeof isHidden === "function" ? isHidden(this.fiscalNotification): isHidden;
      },
      readOnly(readOnly){
        return typeof readOnly === 'function' ? readOnly(this.editable, this.fiscalNotification) : readOnly; 
      },
      sendFromDeviationDialog(data){
        this.deviationData = data;
        console.log(this.deviationData)
        this.infoilDeviationCheckDialogVisible = false;
        this.sendFiscalNotification();
      },
      sendFiscalNotification(){
        this.submitted = true;
        if(!this.v$.fiscalNotification.$invalid){
          this.$refs.confirmLoginDialog.show();
        }
          // TODO - CHIAMATA DI SALVATAGGIO FINALE
          // TODO - PRIMA DI MANDARE LA COMUNICAZIONE DEVO CONTROLLARE CHE HEADER E DETAILS HANNO LO STESSO CIRCUITO FISCALE
          //        IN CASO NEGATIVO CHIEDO CONFERMA PRIMA DI SOSTITUIRLO A TUTTI I DETTAGLI
      },
      resendFiscalNotification(){
        this.submitted = true;
        if(!this.v$.fiscalNotification.$invalid){
          this.$refs.confirmLoginDialogResend.show();
        }
      },
      deleteFiscalNotification(){
        this.$refs.confirmLoginDialogDelete.show();
      },
      editFiscalNotification(){
        this.loadNext();
      },
      reinsertTank(){

        let found = this.fiscalNotificationDetails.find(d => {
          if(d.tank == this.selectedTankNew.tank && d.fiscalNotificationState != 'CC'){
            return true;
          }
          return false;
        })

        if(!found){
          this.fiscalNotificationDetails.push({...this.selectedTankNew});
        }else{
          this.$toast.add({detail:this.$t('fiscalNotification.reinsertTankErrorMessage'), life:3000, severity:'error'});
        }

        if(this.fiscalNotification.fiscalNotificationState == 'CC'){
          this.fiscalNotification.fiscalNotificationState = 'CCP';
          this.fiscalNotification.idRegistryFiscalNotificationState = 0;
        }
        this.selectedTankNew = null;
      },
      onCellEditComplete(){

      },
      setDisableEdit(){
          let opt = this.$refs.fiscalNotificationCombo.getOptions();
          if(opt && opt.length > 0){
            let enabled = opt[opt.length-1].value == this.fiscalNotification.id && this.fiscalNotification.fiscalNotificationState != 'CC';
            this.disableEdit = !enabled;

            let enabledDelete = opt[opt.length-1].value == this.fiscalNotification.id && (this.fiscalNotification.fiscalNotificationState == 'CP' || this.fiscalNotification.fiscalNotificationState == 'CPM');
            this.disableDelete = !enabledDelete;
          }
      },
      removeDetail(data){
        // console.log(data)
      },
      performSend(token){
        
          let data = {...this.fiscalNotification};
          data.idRegistryFiscalNotificationState = 0;
          if(data.fiscalNotificationState != 'CC'){
            data.endOperationDate = null;
          }
          data.fiscalNotificationEquipmentLayouts = [...this.fiscalNotificationEquipmentList]; 
          data.fiscalNotificationDetails = [];
          this.fiscalNotificationDetails.forEach(item => {
            item.idFiscalNotificationCircuit = this.fiscalNotification.idFiscalCircuit;
            item.fiscalNotificationCircuit = this.fiscalNotification.fiscalCircuitCode;
            data.fiscalNotificationDetails.push(item);
          })

          
        console.log(this.deviationData)
          if(this.deviationData){
            data.infoilDeviationCheckData = this.deviationData;
          }
          
          this.$store.dispatch("generic/setLoading", true);
          Service.sendFiscalNotificationWToken(data, token, ( {success, message} ) => {
            this.$store.dispatch("generic/setLoading", false);
            if(success){
              this.$toast.add({severity:'success', detail: this.$t('fiscalNotification.sendSuccessMessage'), life: 3000});
              this.$router.push({name: 'daily-plan-management'})
            }else{
              if(message == 'SHOW_CHECK_DEVIATION_WINDOW'){
                this.infoilDeviationCheckDialogVisible = true;
              }else{
                this.errorSendMessage = message && message != '' ? message :  this.$t('messages.generic_error_message');
                this.errorSendDialogVisible = true;
              }
            }
          });
        
      },
      errorSendDialogCloseCallback(){
        this.errorSendMessage = "";
        this.errorSendDialogVisible = false;
        this.$router.push({name: 'daily-plan-management'});
      },
      performReSend(token){
        
          let data = {...this.fiscalNotification};
          data.fiscalNotificationEquipmentLayouts = [...this.fiscalNotificationEquipmentList]; 
          data.fiscalNotificationDetails = [];
          this.fiscalNotificationDetails.forEach(item => {
            item.idFiscalNotificationCircuit = this.fiscalNotification.idFiscalCircuit;
            item.fiscalNotificationCircuit = this.fiscalNotification.fiscalCircuitCode;
            data.fiscalNotificationDetails.push(item);
          })
          this.$store.dispatch("generic/setLoading", true);
          Service.resendFiscalNotificationWToken(data, token, ( {success, message} ) => {
            this.$store.dispatch("generic/setLoading", false);
            if(success){
              this.$toast.add({severity:'success', detail: this.$t('fiscalNotification.sendSuccessMessage'), life: 3000});
              this.$router.push({name: 'daily-plan-management'})
                
                // this.loadNotifications();
            }else{
              this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          });
        
      },
      performDelete(token){
          this.$store.dispatch("generic/setLoading", true);
          Service.deleteFiscalNotificationWToken(this.idScheduledOperation, token, ( {success, message} ) => {
            this.$store.dispatch("generic/setLoading", false);
            if(success){
              this.$toast.add({severity:'success', detail: this.$t('fiscalNotification.sendSuccessMessage'), life: 3000});
              this.$router.push({name: 'daily-plan-management'})
              //this.loadNotifications();
            }else{
              this.errorSendMessage = message && message != '' ? message :  this.$t('messages.generic_error_message');
              this.errorSendDialogVisible = true;
              // this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
          });
      },
      startEditFiscalNotification(){

        let body = { idScheduledOperation: this.idScheduledOperation};
        this.$store.dispatch("generic/setLoading", true);
        Service.getFiscalNotificationNextState(body, ({success, data, message}) => {
          this.$store.dispatch("generic/setLoading", false);
          if(success){
            this.editable = true;

            this.$refs.fiscalNotificationCombo.addStaticOption({
              label: data.code,
              value: 0,
              extraData: new Date()
            }, true);

            this.fiscalNotification.id = 0;
            this.fiscalNotification.idRegistryFiscalNotificationState = data.id;
            this.fiscalNotification.fiscalNotificationState = data.code;
            this.fiscalNotification.sendNotificationFlag = data.sendNotificationFlag;
            this.fiscalNotification.notificationNumber = this.fiscalNotification.notificationNumber + 1;
            this.fiscalNotification.endOperationDate = data.endOperationDate;
          }else{
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        });

      },
      openEdit(data){
        this.editItem = {...data};
        this.originalEditItem = data;
        if(this.fiscalNotification.isDisplacement){
          this.editDisplacingDetailVisible = true;
        }else{
          this.editDetailVisible = true;
        }
      },
      dialogEditCancel(){
          this.editDetailVisible = false;
      },
      dialogDisplacingEditCancel(){
        this.editDisplacingDetailVisible = false;
      },
      dialogEditSave(){
          // TUTTO OBBLIGATORIO
          // IS 

          if(this.editItem.operationDate == null || this.editItem.temperature == null || this.editItem.temperature == 0 || this.editItem.productLevel == null || this.editItem.productLevel == 0){
              this.$toast.add({detail: this.$t('operativePlan.alertDetailsUpdateRequired'), life:3000, severity:'error'});
              return;
          }

          //this.fiscalNotification.fiscalNotificationState = 'CC';
          this.originalEditItem.enableEdit = true;
          this.originalEditItem.isPartialMeasure = true;
          this.originalEditItem.fiscalNotificationState = 'CC';
          this.originalEditItem.operationDate = this.editItem.operationDate;
          this.originalEditItem.temperature = this.editItem.temperature;
          this.originalEditItem.productLevel = this.editItem.productLevel;
          this.editDetailVisible = false;
      },
      dialogDisplacingEditSave(){
          if(this.editItem.operationDate == null || (this.editItem.fiscalMovedWeight == null  && this.editItem.fiscalMovedVolume == null)){
              this.$toast.add({detail: this.$t('operativePlan.alertDetailsDisplacementUpdateRequired'), life:3000, severity:'error'});
              return;
          }

          this.fiscalNotification.endOperationDate = this.editItem.operationDate;
          for(let i=0; i<this.fiscalNotificationDetails.length; i++){
            this.fiscalNotificationDetails[i].fiscalNotificationState = 'CC';
            this.fiscalNotificationDetails[i].operationDate = this.editItem.operationDate;
          }
          

          this.fiscalNotification.idRegistryFiscalNotificationState = 0;
          this.fiscalNotification.fiscalNotificationState = 'CC';
          this.originalEditItem.enableEdit = true;
          this.originalEditItem.fiscalMovedWeight = this.editItem.fiscalMovedWeight;
          this.originalEditItem.fiscalMovedVolume = this.editItem.fiscalMovedVolume;
          this.originalEditItem.density15 = this.editItem.density15;
          this.editDisplacingDetailVisible = false;
      },
      editDisabled(data){
        if(data.enableEdit){
          return false;
        }

        if(this.fiscalNotification.isDisplacement){
          return !this.editable;
        }

        return !this.editable || data.fiscalNotificationState == 'CC' ;
      },

      exciseCalculate(){
        if(this.editable && this.fiscalNotification.isMovementInstruction && this.fiscalNotification.movementDirectionFlag === 'U' && (this.totalFiscalMovedWeight > 0 || this.totalFiscalMovedVolume > 0)){
          let body = {
            nc: this.$refs.ncCombo.getCompleteValue() ? this.$refs.ncCombo.getCompleteValue().valueString : "",
            idEneryProductDetail: this.fiscalNotification.idEnergyProductDetail,
            idRegistryFiscalPosition: this.fiscalNotification.idRegistryFiscalPosition,
            idRegistryFiscalUse: this.fiscalNotification.idRegistryFiscalUse,
            idRegistryFiscalDestination: this.fiscalNotification.idRegistryFiscalDestination,
            fiscalDate: new Date(),
            movedQuantity: this.totalFiscalMovedWeight,
            movedVolume: this.totalFiscalMovedVolume,
          }
          ExciseCalculatorService.exciseCalculator(body, (response) => {
            if(response.success){
              this.fiscalNotification.exciseDuty = response.data.exciseDuty;
              this.fiscalNotification.exciseDue = response.data.exciseDue;
            }
          })
        }
      },
      deleteDetail(data){

          this.$confirm.require({
            message: this.$t('messages.delete_message_question'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),
            accept: () => {
              let index = this.fiscalNotificationDetails.indexOf(data);
              if(index > -1){
                this.fiscalNotificationDetails.splice(index, 1);
              }
            },
            reject: () => {
                //callback to execute when user rejects the action
                this.$confirm.close();
            }
          });
      },
      addExciseFiscalRegisterByHeaderId(){
        let body = {
          idFiscalNotificationHeader: this.fiscalNotification.id
        }

        this.$confirm.require({
            message: this.$t('messages.generic_confirm_message'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),
            accept: () => {
              Service.addExciseFiscalRegisterByHeaderId(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                  this.$toast.add({severity:'success', detail: this.$t('messages.create_message_success'), life: 3000});
                }else{
                  this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
              });
            },
            reject: () => {
                this.$confirm.close();
            }
          });
      }
    },
    watch: {
      selectedFiscalNotification(newValue){
        if(newValue){
          this.loadCurrent();
        }else{
          this.disableEdit = true;
          this.disableDelete = true;
        }
      },
      totalFiscalMovedWeight(){
        this.exciseCalculate();
      },
      totalFiscalMovedWeight(){
        this.exciseCalculate();
      },
      'fiscalNotification.idEnergyProductDetail'(){
        this.exciseCalculate();
      },
      'fiscalNotification.idRegistryFiscalPosition'(){
        this.exciseCalculate();
      },
      'fiscalNotification.idRegistryFiscalUse'(){
        this.exciseCalculate();
      },
      'fiscalNotification.idRegistryFiscalDestination'(){
        this.exciseCalculate();
      }
      // totalFiscalMoved(newValue){
      //   if(this.fiscalNotification.isMovementInstruction && this.fiscalNotification.movementDirectionFlag === 'U' && newValue && newValue.movedQuantity > 0 && newValue.movedVolume > 0){
      //     console.log("calculateExcises", newValue)
      //     let body = {
      //       nc: this.refs.ncCombo.getCompleteValue().valueString,
      //       idRegistryFiscalPosition: this.fiscalNotification.idRegistryFiscalPosition,
      //       idRegistryFiscalUse: this.fiscalNotification.idRegistryFiscalUse,
      //       idRegistryFiscalDestination: this.fiscalNotification.idRegistryFiscalDestination,
      //       fiscalDate: new Date(),
      //       movedQuantity: newValue.movedQuantity,
      //       movedVolume: newValue.movedVolume,
      //     }
      //     ExciseCalculatorService.exciseCalculator(body, (response) => {
      //       if(response.success){
      //         this.fiscalNotification.exciseDuty = response.data.exciseDuty;
      //         this.fiscalNotification.exciseDue = response.data.exciseDue;
      //       }
      //     })
      //   }
      // }
    },
    computed: {
      uiPermissions(){
        return this.$store.getters['security/uiPermissions'];
      },
      utils(){
        return Utils;
      },
      ncApi(){
        if(this.fiscalNotification.idRegistryProduct){
          let getOnlyValid = this.editable;
          return `masterdata/energy-product-detail-combonc?idProduct=${this.fiscalNotification.idRegistryProduct}&transportType=N&getOnlyValid=${getOnlyValid}`;
        }
        return null;
      },
      disableSend(){
        if(this.fiscalNotification && (this.fiscalNotification.id == null || this.fiscalNotification.id == 0)){

          return false;
        }
        return true;
      },
      constants(){
          return CommonConstants;
      },
      totalFiscalMoved(){
        return {
          movedQuantity: this.totalFiscalMovedWeight,
          movedVolume: this.totalFiscalMovedVolume
        }
      },
      totalFiscalMovedWeight(){
        let w = 0;
        let receiverSum = 0, notReceiverSum = 0;
        if(this.fiscalNotification && this.fiscalNotificationDetails && this.fiscalNotificationDetails.length > 0){
          this.fiscalNotificationDetails.forEach(d => {
            // if(this.fiscalNotification.movementDirectionFlag == 'E' && d.isReceiver){
            if(d.isReceiver){
              // w += d.fiscalMovedWeight ?? 0;
              receiverSum += d.fiscalMovedWeight ?? 0;
            // }else if(this.fiscalNotification.movementDirectionFlag == 'U' && !d.isReceiver){
            }else{
              // w += d.fiscalMovedWeight ?? 0;
              notReceiverSum += d.fiscalMovedWeight ?? 0;
            }
          });
        }

        w = (receiverSum > notReceiverSum) ? receiverSum : notReceiverSum;
        return w;

      },
      totalFiscalMovedVolume(){
      let w = 0;

        let receiverSum = 0, notReceiverSum = 0;
        if(this.fiscalNotification && this.fiscalNotificationDetails && this.fiscalNotificationDetails.length > 0){
          this.fiscalNotificationDetails.forEach(d => {
            // if(this.fiscalNotification.movementDirectionFlag == 'E' && d.isReceiver){
            if(d.isReceiver){
              // w += d.fiscalMovedVolume ?? 0;
              receiverSum += d.fiscalMovedVolume ?? 0;
            // }else if(this.fiscalNotification.movementDirectionFlag == 'U' && !d.isReceiver){
            }else{
              // w += d.fiscalMovedVolume ?? 0;
              notReceiverSum += d.fiscalMovedVolume ?? 0;
            }
          });
        }
        w = (receiverSum > notReceiverSum) ? receiverSum : notReceiverSum;

        return w;
      },
      editColumnVisible(){

        let cond = this.fiscalNotification.fiscalNotificationState != 'CC' && this.fiscalNotification.fiscalNotificationState != 'CA';
        //let condMovementInstructionEBySea = this.fiscalNotification.isMovementInstruction && this.fiscalNotification.isBySea && this.fiscalNotification.movementDirectionFlag == 'E';
        let condMovementInstructionEBySea = this.fiscalNotification.isPartialEndNotificationWithOnlyInputParams;
        let condDisplacement = this.fiscalNotification.isDisplacement;

        return this.editable && ((cond && condMovementInstructionEBySea) || (condDisplacement));
          
      },
      endOperationCheck(){
        let showWarn = false;

        if(this.editable && this.fiscalNotification && this.fiscalNotification.fiscalNotificationState == 'CC' && this.fiscalNotification.endOperationDate && this.fiscalNotification.notificationSendDate){
          let endOpDate = Utils.dateToCurrentTimeZone(this.fiscalNotification.endOperationDate);
          let notSendDate = Utils.dateToCurrentTimeZone(this.fiscalNotification.notificationSendDate);
          let sameDay = (endOpDate.getFullYear() === notSendDate.getFullYear() && endOpDate.getMonth() === notSendDate.getMonth() && endOpDate.getDate() === notSendDate.getDate());
          if(!sameDay){
            return true;
          }
        }

        return showWarn;
      },
      checkFiscalNotificationState(){
        return this.fiscalNotification.fiscalNotificationState == 'CC' && this.fiscalNotification.movementDirectionFlag == 'U';
      }
    }

  };
</script>


<template>
  <main>

    <Dialog v-model:visible="infoilDeviationCheckDialogVisible" :modal="true" :closable="false" :closeOnEscape="false" :style="{width: '40vw'}">
      <InfoilDeviationCheck :idScheduledOperation="idScheduledOperation" @sendFiscalNotification="sendFromDeviationDialog" @cancelSendFiscalNotification="infoilDeviationCheckDialogVisible = false"/>
    </Dialog>

    <Dialog v-model:visible="errorSendDialogVisible" :modal="true" :closable="false" :closeOnEscape="false">
      <Message severity="error" :closable="false">{{errorSendMessage}}</Message>
      <template #footer>
          <Button :label="$t('Ok')" icon="pi pi-close" @click="errorSendDialogCloseCallback" autofocus />
      </template>
    </Dialog>

    <ConfirmLoginDialog ref="confirmLoginDialog" :callback="performSend" />
    <ConfirmLoginDialog ref="confirmLoginDialogResend" :callback="performReSend" />
    <ConfirmLoginDialog ref="confirmLoginDialogDelete" :callback="performDelete" />

    <Dialog v-model:visible="editDetailVisible" :style="{maxWidth: '85vw'}" :modal="true" :closable="false">
      <div class="grid">
        <div class="col-12 lg:col-4">
          <label >{{$t('fiscalNotificationDetail.operationDate')}}</label>
          <Calendar 
            class="w-full"  
              :dateFormat="constants.DATE_FORMAT_POINT"
            :showTime="true" :hideOnDateTimeSelect="true"
            v-model="editItem.operationDate" />
        </div>
        <div class="col-12 lg:col-4">
          <label >{{$t('fiscalNotificationDetail.productLevel')}}</label>
          <InputNumber class="p-inputtext-sm w-full" id="level"  v-model="editItem.productLevel" />
        </div>
        <div class="col-12 lg:col-4">
          <label >{{$t('fiscalNotificationDetail.temperature')}}</label>
          <InputNumber  mode="decimal" 
                        :minFractionDigits="2" :maxFractionDigits="2"
                        class="w-full p-inputtext-sm"  v-model="editItem.temperature" />
        </div>
      </div>
        <template #footer>
          <Button :label="$t('btn.save')" icon="pi pi-save" @click="dialogEditSave" autofocus />
          <Button :label="$t('btn.cancel')" @click="dialogEditCancel" autofocus />
      </template>
    </Dialog>

    <Dialog v-model:visible="editDisplacingDetailVisible" :style="{maxWidth: '85vw'}" :modal="true" :closable="false">
      <div class="grid">
        <div class="col-12 lg:col-3">
          <label >{{$t('fiscalNotificationDetail.operationDate')}}</label>
          <Calendar 
            class="w-full"  
              :dateFormat="constants.DATE_FORMAT_POINT"
            :showTime="true" :hideOnDateTimeSelect="true"
            v-model="editItem.operationDate" />
        </div>
        <div class="col-12 lg:col-3">
          <label >{{$t('fiscalNotificationDetail.fiscalMovedWeight')}}</label>
          <InputNumber class="p-inputtext-sm w-full" id="level" mode="decimal" 
                        :minFractionDigits="3" :maxFractionDigits="3" v-model="editItem.fiscalMovedWeight" />
        </div>
        <div class="col-12 lg:col-3">
          <label >{{$t('fiscalNotificationDetail.fiscalMovedVolume')}}</label>
          <InputNumber class="p-inputtext-sm w-full" id="level" mode="decimal" 
                        :minFractionDigits="3" :maxFractionDigits="3" v-model="editItem.fiscalMovedVolume" />
        </div>
        <div class="col-12 lg:col-3">
          <label >{{$t('fiscalNotificationDetail.density15')}}</label>
          <InputNumber  mode="decimal" 
                        :minFractionDigits="5" :maxFractionDigits="5"
                        class="w-full p-inputtext-sm"  v-model="editItem.density15" />
        </div>
      </div>
        <template #footer>
          <Button :label="$t('btn.save')" icon="pi pi-save" @click="dialogDisplacingEditSave" autofocus />
          <Button :label="$t('btn.cancel')" @click="dialogDisplacingEditCancel" autofocus />
      </template>
    </Dialog>

    <div class="grid">
        <div class="col-12 lg:col-6 field">
          <label for="selectedFiscalNotification">{{$t('fiscalNotification.detail_page_title')}}</label>
          <GenericCustomAutocompleteV2
          :selectLast="true"
            ref="fiscalNotificationCombo"
            :onItemSelect="onFiscalNotificationSelected"
            :disabled="editable"
            v-model="selectedFiscalNotification"
            :format="{label: (e) => e.label + ' - ' + utils.formatDateTime(utils.dateToCurrentTimeZone(e.extraData)), value: 'value'}"
            class=" w-full p-inputtext-sm" />
        </div>
        <div class="col-12 lg:col-4">
          <div class="p-4">
            <ResponsiveButton :label="$t('btn.edit')" icon="pi pi-pencil" class="p-button-outlined p-button-sm my-2 mx-1" :disabled="!uiPermissions('DailyPlan.EditFiscalNotification').isEnabled || disableEdit || editable" @click="startEditFiscalNotification" />
            <ResponsiveButton :label="$t('btn.nextversion')" icon="pi pi-arrow-right" class="p-button-outlined p-button-sm my-2 mx-1" :disabled="!uiPermissions('DailyPlan.EditFiscalNotification').isEnabled || disableEdit || editable" @click="editFiscalNotification" />
            <ResponsiveButton :label="$t('btn.send')" icon="pi pi-envelope" class="p-button-outlined p-button-sm my-2 mx-1" :disabled="!uiPermissions('DailyPlan.SendFiscalNotification').isEnabled || disableSend" @click="sendFiscalNotification" />
            <!-- <ResponsiveButton :label="$t('btn.resend')" icon="pi pi-envelope" class="p-button-outlined p-button-sm my-2 mx-1" :disabled="!uiPermissions('DailyPlan.SendFiscalNotification').isEnabled || !disableSend || editable" @click="resendFiscalNotification" /> -->
            <span v-if="fiscalNotification.canFinalize" class="field">
              <Checkbox v-model="fiscalNotification.isFinal" :binary="true" class="my-3 mx-1" />
              <label class="my-3 mx-1">{{$t('fiscalNotification.cc')}}</label>
            </span>
          </div>
        </div>
        <div class="col-12 lg:col-2">
          <div class="p-4">
            <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-trash" class="p-button-outlined p-button-sm my-2 mx-1" :disabled="!uiPermissions('DailyPlan.DeleteFiscalNotification').isEnabled || disableDelete || editable" @click="deleteFiscalNotification" />
            <ResponsiveButton :label="$t('fiscalNotification.addExciseButton')" icon="pi pi-plus" class="p-button-outlined p-button-sm my-2 mx-1" v-if="!uiPermissions('addExciseFiscalRegisterByHeaderIdButton').isHidden && checkFiscalNotificationState" @click="addExciseFiscalRegisterByHeaderId" />
          </div>
        </div>

        <!-- HEADER -->
        <div class="col-12">
          <Panel :header="`Notification ${fiscalNotification.isProposed ? ' (Proposed)' : ' (Last)'}`" :toggleable="true" v-model:collapsed='collapseNotificationPanel'>
            <div class="grid">
              <div class="col-12">
                <Message v-if="!editable && updates.isMovementInstructionModified" severity="warn" :closable="false">{{$t('fiscalNotification.isMovementInstructionModified')}}</Message>
                <Message v-if="!editable && updates.isScheduledOperationModified" severity="warn" :closable="false">{{$t('fiscalNotification.isScheduledOperationModified')}}</Message>
              </div>
              <div class="col-12 lg:col-3 field">
                <label for="fiscal-circuit" :class="{'p-error': v$.fiscalNotification && v$.fiscalNotification.idFiscalCircuit && v$.fiscalNotification.idFiscalCircuit.$invalid && submitted}">Fiscal circuit</label>
                <GenericCustomAutocompleteV2
                  :disabled="!editable"
                  :changeFn="onFiscalCircuitSelected"
                  api="masterdata/fiscal-circuit-combo"
                  v-model="fiscalNotification.idFiscalCircuit"
                  id="fiscal-circuit"
                  ref="fiscalCircuitCombo"
                  :format="{label:'label', value: 'value'}"
                  :class="{'p-invalid': v$.fiscalNotification.idFiscalCircuit.$invalid && submitted, 'w-full p-inputtext-sm': true}" />
                   <div v-if="((v$.fiscalNotification.idFiscalCircuit.$invalid && submitted) || v$.fiscalNotification.idFiscalCircuit.$pending.$response)">
                      <small class="p-error" v-for="error in v$.fiscalNotification.idFiscalCircuit.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                  </div>
              </div>
              <div class="col-12 md:col-6 lg:col-3 field">
                <label for="energyProductDetail" :class="{'p-error': v$.fiscalNotification && v$.fiscalNotification.idEnergyProductDetail && v$.fiscalNotification.idEnergyProductDetail.$invalid && submitted}">{{$t('energyProduct.nC')}}</label>
                <GenericCustomAutocompleteV2
                  :disabled="!editable"
                  v-model="fiscalNotification.idEnergyProductDetail"
                  :changeFn="onEnergyProductDetailSelected"
                  name="energyProductDetail"
                  ref="ncCombo"
                  :format="{label:'label', value: 'value'}"
                  :class="{'p-invalid': v$.fiscalNotification.idEnergyProductDetail.$invalid && submitted, 'w-full p-inputtext-sm': true}" />
                   <div v-if="((v$.fiscalNotification.idEnergyProductDetail.$invalid && submitted) || v$.fiscalNotification.idEnergyProductDetail.$pending.$response)">
                      <small class="p-error" v-for="error in v$.fiscalNotification.idEnergyProductDetail.$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                  </div>
              </div>

              <template v-for="field in Object.keys(configNotification)" :key="field">
                <div class="col-12 md:col-6 lg:col-3 field" v-if="!isHidden(configNotification[field]?.hidden)">
                  <label :class="{'p-error': v$.fiscalNotification && v$.fiscalNotification[field] && v$.fiscalNotification[field].$invalid && submitted}" :for="field">{{$t('fiscalNotification.'+ field)}}</label>
                  <InputText
                    v-if="(configNotification[field]?.type === 'text') || (configNotification[field]?.type === 'number')"
                    :disabled="readOnly(configNotification[field].readOnly)"
                    :id="field"
                    type="text"
                    v-model="fiscalNotification[field]"
                    :class="{'p-invalid': configNotification[field].required !== 'undefined' && v$.fiscalNotification && v$.fiscalNotification[field] && v$.fiscalNotification[field].$invalid && submitted, 'w-full p-inputtext-sm': true}"
                    class="w-full p-inputtext-sm m-1" />
                  <GenericDateTimeMaskV2 
                    v-if="configNotification[field]?.type === 'datetime'"
                    v-model="fiscalNotification[field]"
                    :readonly="readOnly(configNotification[field].readOnly)"
                    :class="{'p-invalid': configNotification[field].required !== 'undefined' && v$.fiscalNotification && v$.fiscalNotification[field] && v$.fiscalNotification[field].$invalid && submitted, 'w-full p-inputtext-sm': true}"
                     />
                  <GenericDateMaskV2
                    v-if="configNotification[field]?.type === 'date'"
                    v-model="fiscalNotification[field]"
                    :readonly="readOnly(configNotification[field].readOnly)"
                    :class="{'p-invalid': configNotification[field].required !== 'undefined' && v$.fiscalNotification && v$.fiscalNotification[field] && v$.fiscalNotification[field].$invalid && submitted, 'w-full p-inputtext-sm': true}"
                    inputClass="w-full" />
                  <GenericCustomAutocompleteV2
                      v-if="configNotification[field]?.type === 'combo'"
                      :disabled="readOnly(configNotification[field].readOnly)"
                      v-model="fiscalNotification[field]"
                      :format="configNotification[field].format"
                      :ref="field + 'Combo'"
                      :class="{'p-invalid': configNotification[field].required !== 'undefined' && v$.fiscalNotification && v$.fiscalNotification[field] && v$.fiscalNotification[field].$invalid && submitted, 'w-full p-inputtext-sm': true}"
                      :api="configNotification[field].api" />
                    <div v-if="(v$.fiscalNotification && v$.fiscalNotification[field] && ((v$.fiscalNotification[field].$invalid && submitted) || v$.fiscalNotification[field].$pending.$response))">
                      <small class="p-error" v-for="error in v$.fiscalNotification[field].$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                   </div>
                   <GenericCustomAutocompleteV2
                      :disabled="stateComboItems.length < 2"
                      v-if="configNotification[field]?.type === 'state-combo'"
                      v-model="fiscalNotification[field]"
                      :format="configNotification[field].format"
                      :ref="field + 'Combo'"
                      :class="{'p-invalid': configNotification[field].required !== 'undefined' && v$.fiscalNotification && v$.fiscalNotification[field] && v$.fiscalNotification[field].$invalid && submitted, 'w-full p-inputtext-sm': true}"
                      :staticOptions="stateComboItems" />
                    <div v-if="(v$.fiscalNotification && v$.fiscalNotification[field] && ((v$.fiscalNotification[field].$invalid && submitted) || v$.fiscalNotification[field].$pending.$response))">
                      <small class="p-error" v-for="error in v$.fiscalNotification[field].$silentErrors" :key="error.$validator">
                          {{error.$message}}
                      </small>
                   </div>
                   <span class="p-error" v-if="field == 'endOperationDate' && endOperationCheck">{{ $t('fiscalNotification.endOperationDateCheckMessage') }}</span>

                </div>
              </template>
                <div class="col-12 md:col-6 lg:col-3 field" >
                  <label  :for="'totalFiscalMovedWeight'">{{$t('fiscalNotification.totalFiscalMovedWeight')}}</label>
                  <InputText
                    :disabled="true"
                    :id="'totalFiscalMovedWeight'"
                    type="text"
                    v-model="totalFiscalMovedWeight"
                    :class="{'w-full p-inputtext-sm': true}"
                    class="w-full p-inputtext-sm m-1" />
                </div>
                <div class="col-12 md:col-6 lg:col-3 field" >
                  <label  :for="'totalFiscalMovedVolume'">{{$t('fiscalNotification.totalFiscalMovedVolume')}}</label>
                  <InputText
                    :disabled="true"
                    :id="'totalFiscalMovedVolume'"
                    type="text"
                    v-model="totalFiscalMovedVolume"
                    :class="{'w-full p-inputtext-sm': true}"
                    class="w-full p-inputtext-sm m-1" />
                </div>
            </div>
          </Panel>
        </div>
        <div class="col-12">
          <Panel :header="$t('details')" :toggleable="true" v-model:collapsed='collapseNotificationDetailsPanel'>
            <div class="grid" v-if="editable && fiscalNotification.isMovementInstruction">
              <div class="col-9 lg:col-3 field">
                <label for="selectedTank">{{$t('fiscalNotificationDetail.tank')}}</label>
                <GenericCustomAutocompleteV2
                  v-model="selectedTankNew"
                  :api="'fiscal-notification-detail-combo/' + idScheduledOperation"
                  :format="{label: 'label', value: 'extraData'}"
                  class=" w-full p-inputtext-sm" />
              </div>
              <div class="col-3 lg:col-3 field">
                <div class="p-4">
                  <ResponsiveButton :label="$t('btn.insert')" icon="pi pi-plus" class="p-button-outlined p-button-sm my-2 mx-1" :disabled="!selectedTankNew" @click="reinsertTank" />
                </div>
              </div>
            </div>
            <DataTable :reorderableColumns="true" ref="details" :value="fiscalNotificationDetails" v-model:selection="selectedNotificationDetail" selectionMode="single" editMode="cell" @cell-edit-complete="onCellEditComplete" class="editable-cells-table">
              <Column :exportable="false" :reorderableColumn="false" >
                  <template #body="element">
                      <Button icon="pi pi-pencil" class="p-button-rounded p-button-text" :disabled="editDisabled(element.data)" @click="openEdit(element.data)" />
                      <Button icon="pi pi-trash" class="p-button-rounded p-button-text" :disabled="!(editable && fiscalNotification.isMovementInstruction)" @click="deleteDetail(element.data)" />
                    </template>
              </Column>
              <!-- <Column :exportable="false" :reorderableColumn="false">
                <template #body="element">
                  <Checkbox v-model="element.data.isIncluded" :binary="true" :disabled="!editable" />
                </template>
              </Column> -->
              <div v-for="field in Object.keys(configDetails)" :key="field">
                <div v-if="!configDetails[field]?.hidden">
                  <Column v-if="field === 'isReceiver'" :field="field" :header="$t('fiscalNotificationDetail.'+ field)" dataType="boolean">
                    <template #body="element">
                      {{element.data[field] ? $t('fiscalNotificationDetail.receiver') : $t('fiscalNotificationDetail.sender')}}
                    </template>
                  </Column>
                  <div v-else>
                    <Column v-if="(configDetails[field]?.type === 'text') || (configDetails[field]?.type === 'number')" :field="field" :header="$t('fiscalNotificationDetail.'+ field)" dataType="string">
                    </Column>
                    <Column v-if="configDetails[field]?.type === 'date'" :field="field" :header="$t('fiscalNotificationDetail.'+ field)" dataType="date">
                      <template #body="element">
                        {{element.data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data[field])) : null}}
                      </template>
                    </Column>
                    <Column v-if="configDetails[field]?.type === 'datetime'" :field="field" :header="$t('fiscalNotificationDetail.'+ field)" dataType="date">
                      <template #body="element">
                        {{element.data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data[field]), 'DD/MM/yy HH:mm') : null}}
                      </template>
                    </Column>
                    <Column v-if="configDetails[field]?.type === 'boolean'" :field="field" :header="$t('fiscalNotificationDetail.'+ field)" dataType="boolean">
                      <template #body="element">
                        <i class="pi" :class="{'true-icon pi-check-circle': element.data[field], 'false-icon pi-times-circle': !element.data[field]}"></i>
                      </template>
                    </Column>
                  </div>
                </div>
              </div>
              <template #empty>
                {{$t('noRecordsFound')}}
              </template>
            </DataTable>
          </Panel>
        </div>
        <div class="col-12">
          <Panel :header="$t('operativePlan.equipments')" :toggleable="true" v-model:collapsed='collapseEquipmentListPanel'>
            <DataTable :reorderableColumns="true" ref="equipmentList" :value="fiscalNotificationEquipmentList">
              <Column field="equipment" :header="$t('fiscalNotification.equipmentCode')" />
              <Column field="equipmentDescription" :header="$t('fiscalNotification.equipmentDescription')" />
              <Column field="equipmentType" :header="$t('fiscalNotification.equipmentType')" />
              <template #empty>
                {{$t('noRecordsFound')}}
              </template>
            </DataTable>
          </Panel>
        </div>
      </div>
  </main>
</template>